import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import './HomeNew.css';
import HomeNew from './components/HomeNew';
import Catalog from './components/Catalog';
import Admin from './components/Admin';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Cart, { CartProvider } from './components/Cart';
import StructuredData from './components/StructuredData';

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <Router>
          <StructuredData />
          <Routes>
            <Route path="/" element={<HomeNew />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
          <Cart />
        </Router>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;